module.exports = __webpack_public_path__ + "media/2022/CNN-c0cc8ce8.png";